module.exports = __webpack_public_path__ + "static/intro.309cfd4a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/intro.mp4
// module id = 527
// module chunks = 35783957827783